import apiService from "./apiServices";

export const saveTask = async(formData, token) => {
    try {

        const response = await apiService('/addtask/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving task is failed. Please try again.');
        }
  }


export const searchTask = async (formData, token, policyId, page = 0, size = 5) => {
  try {
    const baseEndpoint = policyId
      ? `/addtask/search/${policyId}?page=${page}&size=${size}`
      : `/addtask/search?page=${page}&size=${size}`;

    // Convert formData into query params
    const buildQueryParams = (params) =>
      Object.entries(params || {})
        .filter(([_, value]) => value !== null && value !== undefined && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    const queryParams = buildQueryParams(formData);
    const url = queryParams
      ? `${baseEndpoint}&${queryParams}&sort=desc`
      : `${baseEndpoint}&sort=desc`;

    // ✅ Always GET
    const response = await apiService(url, "GET", null, null, token);

    return response ?? [];
  } catch (error) {
    throw new Error(error?.message || "Search task failed.");
  }
};


  export const searchTaskCalendar = async (formData, token) => {
    try {
        const query = encodeURIComponent(formData.query.trim());  // Encode query for safety
        const response = await apiService(`/addtask/search?search=${query}`, 'GET', null, null, token);
        return response;
    } catch (error) {
        throw error?.message || 'Search task failed. Please try again.';
    }
};

export const searchTaskLinear = async (formData, token, page, size) => {
  try {
      const query = encodeURIComponent(formData.query.trim());
      const response = await apiService(
        `/addtask/search?fromDate=${formData.fromDate}&toDate=${formData.toDate}&search=${query}&page=${page}&size=${size}&sort=desc`,
        'GET',
        null,
        null,
        token
    );

      return response;
  } catch (error) {
      throw error?.message || 'Search task failed. Please try again.';
  }
};

export const searchCommonTask = async (formData, token, page, size) => {
  try {
    const requestBody = {
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      taskType: formData.taskType,
      page,
      size,
      sort: 'desc'
    };

    const response = await apiService(
      `/addtask/searchTaskType`,
      'POST',  // Corrected: Now using POST
      requestBody,
      null,
      token
    );

    return response;
  } catch (error) {
    throw error?.message || 'Search task failed. Please try again.';
  }
};

  export const updateTask = async (formData, token) => {
    try {
      const response = await apiService('/addtask/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating task is failed. Please try again.');
      }
  }

export const getClientCustomer = async (id, token) => {
  try {
      const response = await apiService(`/client-customers/get/${id}`, 'GET',null,null, token);
      return response;
  } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
  }
};

  export const getAllTask = async ( token, page, size, fromDate = null, toDate = null ) => {
    try {
      let url = `/addtask/search?page=${page}&size=${size}&sort=desc`;

      if (fromDate && toDate) {
        url += `&fromDate=${fromDate}&toDate=${toDate}`;
      }      
  const response = await apiService(url, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
    }
  };

  export const deleteTaskById = async (id, token) => {
    try {
      const response = await apiService(`/addtask/delete/${id}`, 'DELETE', null, null, token);

      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const getDueTask = async (token, page, size, fromDate = null, toDate = null, status = "Open") => {
    try {
      let url = `/addtask/filter?page=${page}&size=${size}&sort=desc`;
      const todayDate = new Date()
      const yesterday = new Date(todayDate)
      yesterday.setDate(todayDate.getDate() - 1)
      const formattedDate=yesterday.toISOString().split("T")[0]
      if (formattedDate) {
        url += `&dueDate=${formattedDate}`;
      }

      if (status) {
        url += `&status=${status}`;
      }

      const response = await apiService(url, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw error?.message || 'Service failed. Please try again.';
    }
  };

  export const getTaskByPolicy= async (token,policyId, page, size) => {
    try {

      const response = await apiService(`/addtask/policy/${policyId}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const searhUserTaskServices= async (token,searchterm, page, size) => {
    try {

      const response = await apiService(`/addtask/search/users?searchTerm=${searchterm}&page=${page}&size=${size}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'All search user task service is failed. Please try again.');
    }
  }

  export const getTypeOfTaskOpenServices = async (token) => {
    try {
        const response = await apiService(`/task-types/names`, 'GET',null,null, token);
        return response;
    } catch (error) {
        throw (error?.message || 'Service failed. Please try again.');
    }
  };

   export const getCustomerByPolicyId= async (policyId,token) => {
    try {

      const response = await apiService(`/policy/${policyId}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }